export default __webpack_public_path__ + "static/media/cancer_Hk.653548a6.webp";